import { Button, Card, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import React, { useContext, useEffect, useState } from 'react';
import { useContextInfo } from '../../context/ContextInfo';
import { useForm } from '../../hooks/useForm';
import { fetchConToken } from '../../api/fetch';
import moment from 'moment/moment';
import NominaPrint from './NominaPrint';
import { AuthContext } from '../../auth/AuthContext';
// Obtener la fecha actual
const today = moment();

// Determinar los valores de inicio y fin
let inicioe, fine;
if (today.date() <= 15) {
    inicioe = moment().startOf('month').format('YYYY-MM-DD'); // Primer día del mes actual
    fine = moment().date(15).format('YYYY-MM-DD'); // Día 15 del mes actual
} else {
    inicioe = moment().date(16).format('YYYY-MM-DD'); // Día 15 del mes actual
    fine = moment().endOf('month').format('YYYY-MM-DD'); // Último día del mes actual
}

const ModNomina = ({ dia, show, onClose, user }) => {
    const { setResp } = useContextInfo();
    const id_emp = localStorage.getItem('idemployed');
    const { auth } = useContext(AuthContext);
    const [codigos, setCodigos] = useState({ codigo: '#####', folio: 'VRT#-000' });
    const [load, setLoad] = useState(false);
    const [validated, setValidated] = useState(false);
    const [start, setStart] = useState(inicioe);
    const fechac = moment().add(1, 'week').format('YYYY-MM-DD');
    const [values, handleInputChange, reset, setFormValue] = useForm({
        inicio: inicioe,
        fin: fine,
        faltas: 0,
        extra: 0,
        transferencia: 0,
        efectivo: 0,
        total: 0,
        monto: 400,
        fecha: moment().format('YYYY-MM-DD'),
        caduca: fechac,
    });
    const { extra, faltas, fin } = values;
    const { inicio_labores, vale } = user;
    const funClose = () => {
        reset();
        onClose();
    };
    useEffect(() => {
        if (moment(start).isBefore(moment(inicio_labores))) {
            setStart(inicio_labores);
        }
    }, [inicio_labores]);
    useEffect(() => {
        if (vale) getDataVale();
    }, [vale, show]);

    const getDataVale = async () => {
        const datos = await fetchConToken('nominas/dataval');
        if (datos.ok) setCodigos(datos.data);
    };
    useEffect(() => {
        let diasServicio = 0;

        const inicioLaboresMoment = moment(start, 'YYYY-MM-DD'); // Parseando la fecha correctamente
        const finLaboresMoment = moment(fin, 'YYYY-MM-DD'); // Parseando la fecha correctamente

        if (!inicioLaboresMoment.isValid()) {
            console.error('Fecha de inicio de labores no es válida');
        } else {
            // Calculando la diferencia de días
            diasServicio = moment(finLaboresMoment).diff(inicioLaboresMoment, 'days');
            diasServicio += 1; // Incluye el primer día en el cálculo
        }

        // Verifica si el mes es febrero (mes 1 en formato de moment)
        if (inicioLaboresMoment.month() === 1 || finLaboresMoment.month() === 1) {
            // Si es febrero, asegúrate de que los días de servicio no sean menores a 15
            diasServicio = Math.max(diasServicio, 15);
        }

        console.log('dias', diasServicio);

        let total = 0;
        if (diasServicio >= 15) {
            total = Math.round(dia * 15); // Si son 15 o más días, se calcula como 15 días
        } else {
            total = Math.round(dia * diasServicio); // Si no, se usa el número de días calculado
        }

        // Agregar el total por extras
        if (extra > 0) {
            total += extra * dia * 2;
        }

        // Restar el total por faltas
        if (faltas > 0) {
            let totalFaltas = dia * 1.16 * faltas;
            total -= totalFaltas;
        }

        setFormValue({
            ...values,
            total,
        });
    }, [start, fin, faltas, extra]);

    const onSubmit = async (e) => {
        const form = e.currentTarget;
        e.preventDefault();
        setLoad(true);
        if (form.checkValidity() === false) {
            setValidated(true);
        } else {
            let res = await fetchConToken(
                `nominas/employe/nomina`,
                { ...values, id_emp, dia, agente: auth.uid, inicio: start, vale: user.vale, ...codigos },
                'POST'
            );
            setResp(res);
            // callBk();
            reset();
            onClose();
        }
        setLoad(false);
    };
    return (
        <Modal show={show} onHide={funClose} dialogClassName="modal-full-width">
            <Modal.Header onHide={funClose} closeButton>
                <h4 className="modal-title"> Nueva nomina</h4>
            </Modal.Header>
            <Modal.Body>
                <>
                    <Row>
                        <Col sm="4">
                            <Card>
                                <Card.Header className="bg-secondary fw-bolder text-white">Datos</Card.Header>
                                <Card.Body>
                                    <Form noValidate validated={validated} onSubmit={onSubmit}>
                                        <Row>
                                            <Col>
                                                <Form.Group className="mb-3" controlId="validationCustom01">
                                                    <Form.Label>Periodo</Form.Label>
                                                    <Form.Control
                                                        required
                                                        type="date"
                                                        value={start}
                                                        name="start"
                                                        onChange={(e) => setStart(e.target.value)}
                                                    />

                                                    <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                                </Form.Group>{' '}
                                            </Col>
                                            <Col>
                                                <Form.Group className="mb-3" controlId="validationCustom01">
                                                    <Form.Label>al</Form.Label>

                                                    <Form.Control
                                                        required
                                                        type="date"
                                                        value={values.fin}
                                                        name="fin"
                                                        onChange={handleInputChange}
                                                    />
                                                    <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                                </Form.Group>{' '}
                                            </Col>
                                        </Row>{' '}
                                        <Row>
                                            <Col>
                                                <Form.Group className="mb-3" controlId="validationCustom004">
                                                    <Form.Label>Faltas del mes</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        value={values.faltas}
                                                        name="faltas"
                                                        required
                                                        onChange={handleInputChange}
                                                    />
                                                </Form.Group>
                                                <Form.Control.Feedback>Válido</Form.Control.Feedback>{' '}
                                            </Col>
                                            <Col xs lg="4">
                                                <Form.Group className="mb-3" controlId="validationCustom05">
                                                    <Form.Label>Dias no laborables</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        value={values.extra}
                                                        name="extra"
                                                        required
                                                        onChange={handleInputChange}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        Ingrese una cantidad
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>

                                            <Col xs lg="4">
                                                <Form.Group className="mb-3" controlId="validationCustom05">
                                                    <Form.Label>Pago en transferencia</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        value={values.transferencia}
                                                        name="transferencia"
                                                        required
                                                        onChange={handleInputChange}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        Ingrese una facha
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        {user.vale && (
                                            <Row>
                                                <Card.Header className="bg-light fw-bolder mb-2">
                                                    Datos del vale de despensa
                                                </Card.Header>

                                                <Col xs lg="6">
                                                    <Form.Group className="mb-3" controlId="validationCustom05">
                                                        <Form.Label>Monto de vale</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            value={values.monto}
                                                            name="monto"
                                                            required
                                                            onChange={handleInputChange}
                                                        />
                                                        <Form.Control.Feedback type="invalid">
                                                            Ingrese un monto del vale de despensa
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                </Col>
                                                <Col xs lg="6">
                                                    <Form.Group className="mb-3" controlId="validationCustom05">
                                                        <Form.Label>Valido hasta</Form.Label>
                                                        <Form.Control
                                                            type="date"
                                                            value={values.caduca}
                                                            name="caduca"
                                                            required
                                                            onChange={handleInputChange}
                                                        />
                                                        <Form.Control.Feedback type="invalid">
                                                            Ingrese una fecha valida
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        )}
                                        {load ? (
                                            <Button color="primary" disabled>
                                                <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                                                Guardando...
                                            </Button>
                                        ) : (
                                            <Button type="submit">Guardar</Button>
                                        )}
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                        <NominaPrint
                            data={{ ...values, dia, inicio: start, ...codigos }}
                            user={user}
                            onClose={funClose}
                        />
                    </Row>
                </>
            </Modal.Body>
        </Modal>
    );
};

export default ModNomina;
